export default {
  None: 'none',
  Begin: 'begin',
  Closed: 'closed',
}
